import './App.css';

// react =>
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';

// pages =>
import Products from './pages/products/products.page';
import Portfolio from './pages/portfolio/portfolio.page';
import LandingPage from './pages/landing-page/landing-page.page';

// Animation =>
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
    const location = useLocation();

    useEffect(() => {
        AOS.init({
            duration: 900,
            once: true,
            easing: 'ease-in-out',
            offset: 80,
            delay: 0,
            mirror: false,
            anchorPlacement: 'top-bottom',
        });
    }, []);

    useEffect(() => {
        const refreshAnimation = window.requestAnimationFrame(() => {
            AOS.refreshHard();
        });

        return () => window.cancelAnimationFrame(refreshAnimation);
    }, [location.pathname]);

    return (
        <Routes>
            <Route path='/' element={ <LandingPage /> } />
            <Route path='/products' element={ <Products /> } />
            <Route path='/portfolio' element={ <Portfolio /> } />
        </Routes>
    );
}

export default App;
